document.addEventListener("DOMContentLoaded", function(){
  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      const square = entry.target.querySelector('.animatethis');
      console.log(entry);
      console.log(square);

      if (entry.isIntersecting && entry.intersectionRatio >= 1) {
        square.classList.add('animate');
      }

    });
  }, { rootMargin: '0px', threshold: 1 });

  const containers = document.querySelectorAll('.animationcontainer');
  containers.forEach(container => {
    observer.observe(container);
  });
});